export default __webpack_public_path__ + "static/media/third-item-bg.e80c519f.svg";